var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugmentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 76,
    viewBox: "0 0 90 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0378 76.0001C67.9665 73.417 50.9278 64.1942 46.2325 45.8729H54.0789L49.5112 38.0007L44.9434 30.1272L40.3756 38.0007L35.8079 45.8729H43.6543C38.9591 64.1955 21.9216 73.4183 0.848999 76.0001L22.8961 38.002L40.9866 6.82078L44.9434 0L48.9001 6.82066L66.9918 38.0019L89.0378 76.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmentLogo);
export default __webpack_public_path__ + "static/media/augment-logo.0780e279f6b29cb4ff7bf1890816a65f.svg";
export { ForwardRef as ReactComponent };